import { Box, Card, Grid, Typography } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import DadosPessoalEdit from "../dadosGenericos/dadosPessoalEdit";
import { useState } from "react";
import FotoEdit from "../../utils/fotoEdit";
import Delete from "../../utils/delete";
import RepresentanteCreateDirectorTecnico from "./representanteCreateDirectorTecnico";


export default function FichaRepresentante({ representante, header, setRefresh }) {
    const [editDados, setEditDados] = useState(false)
    const [openEditFoto, setOpenEditFoto] = useState(false);
    const [dadosPessoalRepresentante, setDadosPessoalRepresentante] = useState(representante)
    const [open, setOpen] = useState(false);
    const [openRCDT, setOpenRCDT] = useState(false);

    // console.log(representante)

    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );

    return (
        <>
            {representante ?
                <Card style={{ padding: 20, minHeight: '20vh', marginBottom: 20 }}>

                    <Delete
                        open={open}
                        setOpen={setOpen}
                        url={'/representante/delete'}
                        msg={`Tem certeza que deseja eliminar Representante ${representante?.dadosPessoais?.nome}`}
                        id={representante._id}
                    />

                    <RepresentanteCreateDirectorTecnico
                        open={openRCDT}
                        setOpen={setOpenRCDT}
                        representante={representante}
                    />

                    {header &&
                        <HeaderGestorConfigs
                            menu={true}
                            configArea={'fichaRepresentante'}
                            title={editDados ? 'EDITAR DADOS' : 'FICHA DE REPRESENTANTE'}
                            representante={representante}
                            editDados={editDados}
                            setEditDados={setEditDados}
                            representanteCreateDirectorTecnico={setOpenRCDT}
                            delete={setOpen}
                        />
                    }

                    {!editDados ?
                        <Grid container>
                            <Grid item marginRight={2}>
                                <FotoEdit
                                    openEditFoto={openEditFoto}
                                    setOpenEditFoto={setOpenEditFoto}
                                    dadosPessoal={representante?.dadosPessoais} />
                            </Grid>

                            <Grid xs item >
                                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                                    <Grid container spacing={2}>
                                        {/* {renderField('Estado', representante?.dadosPessoais.status)} */}
                                        {renderField('Nome', representante?.dadosPessoais.nome)}
                                        {renderField('B.I', representante?.dadosPessoais.bi)}
                                        {renderField('Telefone1', representante?.dadosPessoais.tel1)}
                                        {renderField('E-mail', representante?.dadosPessoais.email)}
                                        {renderField('Telefone2', representante?.dadosPessoais?.tel2 ?? '')}
                                        {renderField('Provincia', representante?.dadosPessoais.provincia)}
                                        {renderField('Município', representante?.dadosPessoais.municipio)}
                                        {renderField('Bairro', representante?.dadosPessoais.bairro)}
                                        {renderField('Rua / Avenida', representante?.dadosPessoais.rua)}
                                        {renderField('Nacionalidade', representante?.dadosPessoais.nacionalidade)}
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                        :
                        <DadosPessoalEdit
                            dadosPessoais={representante.dadosPessoais}
                            setDadosPessoais={setDadosPessoalRepresentante}
                            cancelEditDados={setEditDados}
                            setRefresh={setRefresh}
                        />
                    }
                </Card>
                :
                <Loading />
            }
        </>
    )
}